import Footer from "./comm/Footer";
import Navbar from "./comm/Navbar";

function Testimonials(){
    return (
        <>
        <Navbar />

         <section className="py-5">
        <div className="container">
          <div className="testimonial-header text-center mb-5">
            <h2 className="testimonial-title">Client Experiences</h2>
            <div className="testimonial-underline mx-auto"></div>
          </div>

          <div className="row g-4">
            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Great fitting and quality service! The attention to detail is remarkable."</p>
                <div className="client-info">
                  <h6 className="client-name">Ravi Kulkarni</h6>
                  <p className="client-detail">Regular Customer</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Timely delivery and perfect tailoring. Exceeded my expectations!"</p>
                <div className="client-info">
                  <h6 className="client-name">Amit Desai</h6>
                  <p className="client-detail">Business Professional</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Highly recommended for custom wear! Perfect fit every time."</p>
                <div className="client-info">
                  <h6 className="client-name">Nikhil Joshi</h6>
                  <p className="client-detail">Wedding Client</p>
                </div>
              </div>
            </div>

             <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Great fitting and quality service! The attention to detail is remarkable."</p>
                <div className="client-info">
                  <h6 className="client-name">Ravi Kulkarni</h6>
                  <p className="client-detail">Regular Customer</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Timely delivery and perfect tailoring. Exceeded my expectations!"</p>
                <div className="client-info">
                  <h6 className="client-name">Amit Desai</h6>
                  <p className="client-detail">Business Professional</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Highly recommended for custom wear! Perfect fit every time."</p>
                <div className="client-info">
                  <h6 className="client-name">Nikhil Joshi</h6>
                  <p className="client-detail">Wedding Client</p>
                </div>
              </div>
            </div>


             <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Great fitting and quality service! The attention to detail is remarkable."</p>
                <div className="client-info">
                  <h6 className="client-name">Ravi Kulkarni</h6>
                  <p className="client-detail">Regular Customer</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Timely delivery and perfect tailoring. Exceeded my expectations!"</p>
                <div className="client-info">
                  <h6 className="client-name">Amit Desai</h6>
                  <p className="client-detail">Business Professional</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Highly recommended for custom wear! Perfect fit every time."</p>
                <div className="client-info">
                  <h6 className="client-name">Nikhil Joshi</h6>
                  <p className="client-detail">Wedding Client</p>
                </div>
              </div>
            </div>

             <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Great fitting and quality service! The attention to detail is remarkable."</p>
                <div className="client-info">
                  <h6 className="client-name">Ravi Kulkarni</h6>
                  <p className="client-detail">Regular Customer</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Timely delivery and perfect tailoring. Exceeded my expectations!"</p>
                <div className="client-info">
                  <h6 className="client-name">Amit Desai</h6>
                  <p className="client-detail">Business Professional</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial-card " data-aos="zoom-in">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="testimonial-text">"Highly recommended for custom wear! Perfect fit every time."</p>
                <div className="client-info">
                  <h6 className="client-name">Nikhil Joshi</h6>
                  <p className="client-detail">Wedding Client</p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>

      <Footer />

        </>
    );
}

export default Testimonials;